<kendo-dropdownbutton fillMode="flat" [data]="data()" (itemClick)="changeLanguage($event)">
  {{ currentLanguage() | uppercase }}
  <ng-template kendoDropDownButtonItemTemplate let-dataItem>
    <span>{{ dataItem.text | uppercase }}</span>
  </ng-template>
</kendo-dropdownbutton>
